<template>
  <div class="grid">
    <div class="col-12">
      <div class="apps">
      <div data-landmark="true" class="planHubPage" role="main">
        <div class="empty">
          <img class="image" src="/layout/images/tasks.png">
          <div class="welcome">{{ $t('main_page.welcome', { name: user.full_name }) }}</div>
          <div class="description">{{ $t('main_page.description') }}</div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";

export default {
  computed:{
    user() {
      return store.state.user.data
    },
  }
}
</script>

<style scoped>
.apps {
  flex: 1 1 0px;
  min-height: 0px;
  min-width: 0px;
}

 .planHubPage {
   padding: 16px 40px;
   overflow-y: auto;
 }
.empty {
  display: block;
  text-align: center;
}
.image {
  height: 300px;
  margin-top: 15px;
  width: 300px;
}
.welcome {
  font-size: 28px;
  font-weight: 100;
  font-weight: 600;
  margin-top: 47px;
}
.description {
  align-items: center;
  display: "-webkit-flex";
  display: "-moz-flex";
  display: "-ms-flexbox";
  display: "-ms-flex";
  display: flex;
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -moz-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  font-size: 15px;
  font-weight: 400;
  justify-content: center;
  margin-top: 37px;
}
</style>
